import { render, staticRenderFns } from "./CastCrew.vue?vue&type=template&id=6d3db1b7&scoped=true&"
import script from "./CastCrew.vue?vue&type=script&lang=js&"
export * from "./CastCrew.vue?vue&type=script&lang=js&"
import style0 from "./CastCrew.vue?vue&type=style&index=0&id=6d3db1b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3db1b7",
  null
  
)

export default component.exports